"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _ApiClient = _interopRequireDefault(require("../ApiClient"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
/**
 * eXtend Media Paywall Service API
 * Media Wall API Specification
 *
 * The version of the OpenAPI document: v1
 * Contact: t.ioannidis@extend.gr
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

/**
 * The RequestSubscriptionCancellationModel model module.
 * @module model/RequestSubscriptionCancellationModel
 * @version 1.1.3-alpha.1
 */
class RequestSubscriptionCancellationModel {
  /**
   * Constructs a new <code>RequestSubscriptionCancellationModel</code>.
   * @alias module:model/RequestSubscriptionCancellationModel
   * @param token {String} 
   */
  constructor(token) {
    RequestSubscriptionCancellationModel.initialize(this, token);
  }

  /**
   * Initializes the fields of this object.
   * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
   * Only for internal use.
   */
  static initialize(obj, token) {
    obj['token'] = token;
  }

  /**
   * Constructs a <code>RequestSubscriptionCancellationModel</code> from a plain JavaScript object, optionally creating a new instance.
   * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @param {module:model/RequestSubscriptionCancellationModel} obj Optional instance to populate.
   * @return {module:model/RequestSubscriptionCancellationModel} The populated <code>RequestSubscriptionCancellationModel</code> instance.
   */
  static constructFromObject(data, obj) {
    if (data) {
      obj = obj || new RequestSubscriptionCancellationModel();
      if (data.hasOwnProperty('token')) {
        obj['token'] = _ApiClient.default.convertToType(data['token'], 'String');
      }
    }
    return obj;
  }

  /**
   * Validates the JSON data with respect to <code>RequestSubscriptionCancellationModel</code>.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @return {boolean} to indicate whether the JSON data is valid with respect to <code>RequestSubscriptionCancellationModel</code>.
   */
  static validateJSON(data) {
    // check to make sure all required properties are present in the JSON string
    for (const property of RequestSubscriptionCancellationModel.RequiredProperties) {
      if (!data[property]) {
        throw new Error("The required field `" + property + "` is not found in the JSON data: " + JSON.stringify(data));
      }
    }
    // ensure the json data is a string
    if (data['token'] && !(typeof data['token'] === 'string' || data['token'] instanceof String)) {
      throw new Error("Expected the field `token` to be a primitive type in the JSON string but got " + data['token']);
    }
    return true;
  }
}
RequestSubscriptionCancellationModel.RequiredProperties = ["token"];

/**
 * @member {String} token
 */
RequestSubscriptionCancellationModel.prototype['token'] = undefined;
var _default = RequestSubscriptionCancellationModel;
exports.default = _default;